import { render, staticRenderFns } from "./activity_ios_andriod.vue?vue&type=template&id=5b4ff14e"
import script from "./activity_ios_andriod.vue?vue&type=script&lang=js"
export * from "./activity_ios_andriod.vue?vue&type=script&lang=js"
import style0 from "./activity_ios_andriod.vue?vue&type=style&index=0&id=5b4ff14e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports